import React from 'react';
import "./ToggleInput.scss";

const ToggleInput = ({ boldColours, secondLabel, switchContainerClassName, id, onChange, name, checked, onClick }) => {

    let className = "slider round";
    if (boldColours) {
        className += " colours-off-on";
    }
    if (secondLabel) {
        className += " colours-toggle-between"
    }
    return (
        <div className={`switch-input-container${switchContainerClassName ?' ' + switchContainerClassName : ''}`}>
            <label className="switch" >
                <input id={id} onChange={onChange} type="checkbox" name={name} className="selected" checked={checked} />
                <span
                    className={className}
                    onClick={onClick}
                />
            </label>
        </div>
    );
}

export default ToggleInput;